import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import * as sha256 from 'sha256';

export default class ResetPasswordRequest extends GenericRequest {

    token;
    password;

    constructor(password, token) {
        super(METHOD_POST, ApiEndpoints.RESET_PASSWORD);

        this.token = token;
        this.password = password;
    }

    overrideRequest() {
        const request = {};
        if ( this.token ) request.token = this.token;
        if ( this.password ) request.password = sha256(this.password);
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/login/ws/ResetPasswordRequest.js